module.exports = __webpack_public_path__ + "assets/img/garage_automatic_parking.71c24bcb.svg";